import { render } from "./App.vue?vue&type=template&id=8abd3c58"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8abd3c58&lang=css"

import exportComponent from "C:\\Users\\sun\\WebstormProjects\\untitled1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__